import { ChangeEvent, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";

type Props = {
  onChange: (value: string) => void;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick: () => void;
  onCollectionRemove?: () => void;
};

const useManageCollectionModal = ({
  onChange,
  onCollectionRemove,
  onSecondaryButtonClick,
  onPrimaryButtonClick,
}: Props) => {
  const { t } = useTranslation(TranslationContext.Settings);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  const handlePrimaryButtonClick = useCallback(() => {
    onPrimaryButtonClick();
  }, [onPrimaryButtonClick]);

  const handleSecondaryButtonClick = useCallback(() => {
    onSecondaryButtonClick();
  }, [onSecondaryButtonClick]);

  const handleCollectionRemove = useCallback(() => {
    onCollectionRemove && onCollectionRemove();
  }, [onCollectionRemove]);

  return {
    t,
    handleChange,
    handlePrimaryButtonClick,
    handleSecondaryButtonClick,
    handleCollectionRemove,
  };
};

export default useManageCollectionModal;
